import {
  FormControl,
  FormErrorMessage,
  Radio,
  RadioGroup,
} from "@chakra-ui/react";
import { DEFAULT_LANGUAGE, Language, translate as t } from "@models/language";
import { isEmpty } from "lodash";
import {
  FieldErrors,
  FieldValues,
  RegisterOptions,
  UseFormRegister,
} from "react-hook-form";
import DynamicFormFieldHeader from "./DynamicFormFieldHeader";
import { Field } from "./types";

const DynamicFormRadio = ({
  field,
  errors,
  register,
  language: language = DEFAULT_LANGUAGE,
  isDirty: isDirty = true,
  className: className = "",
}: {
  field: Field;
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
  language?: Language;
  isDirty?: boolean;
  className?: string;
}) => {
  // TODO: default translation
  const _t = (key?: string, language = DEFAULT_LANGUAGE) => key || "";

  // https://tailwindcss.com/docs/content-configuration#dynamic-class-names
  let colSpan = "sm:col-span-1";
  switch (field.span) {
    case 1:
      colSpan = "sm:col-span-1";
      break;
    case 2:
      colSpan = "sm:col-span-2";
      break;
    case 3:
      colSpan = "sm:col-span-3";
      break;
    case 4:
      colSpan = "sm:col-span-4";
      break;
  }

  const toRegisterOptions = (
    field: Field
  ): RegisterOptions<FieldValues, string> => {
    return {
      ...(field.required
        ? {
            required:
              t(field.errorMessages?.required, language) ||
              _t("This field is required", language),
          }
        : {}),
    };
  };

  if (!field.options || isEmpty(field.options)) return <></>;
  return (
    <>
      <FormControl
        isInvalid={isDirty && !!errors[field.key]}
        className={`${field.span ? colSpan : ""} col-span-1 ${className}`}
        isRequired={field.required}
        isDisabled={field.disabled}
        isReadOnly={field.readonly}
      >
        <DynamicFormFieldHeader field={field} language={language} />
        <RadioGroup
          colorScheme="primary"
          defaultValue={
            (
              field.options.find((option) => option.selected) ||
              field.options[0]
            ).value
          }
        >
          <div className="flex flex-col">
            {field.options.map((option, i) => (
              <Radio
                key={i}
                colorScheme="primary"
                value={option.value}
                {...register(field.key, {
                  ...toRegisterOptions(field),
                })}
              >
                {t(option.label, language) || option.value}
              </Radio>
            ))}
          </div>
        </RadioGroup>

        <FormErrorMessage>
          {String(errors[field.key]?.message || "")}
        </FormErrorMessage>
      </FormControl>
    </>
  );
};

export default DynamicFormRadio;
